interface LogoProps {
  variant?: 'default' | 'onDark';
  className?: string;
}

/**
 * HCP (Hauptstadt Consulting Partners) wordmark logo.
 * Text-based, uses Playfair Display for the monogram and Inter for the wordmark.
 */
const Logo = ({ variant = 'default', className = '' }: LogoProps) => {
  const isDark = variant === 'onDark';
  const monogramColor = isDark ? 'text-white' : 'text-primary';
  const wordmarkColor = isDark ? 'text-white/85' : 'text-foreground/85';
  const dividerColor = isDark ? 'bg-white/30' : 'bg-foreground/25';

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span
        className={`font-serif font-semibold tracking-tight text-[22px] leading-none ${monogramColor}`}
        style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
      >
        HCP
      </span>
      <span className={`h-4 w-px ${dividerColor}`} aria-hidden="true" />
      <span
        className={`text-[10px] uppercase tracking-[0.22em] font-semibold ${wordmarkColor}`}
      >
        Hauptstadt<br />Consulting Partners
      </span>
    </span>
  );
};

export default Logo;
